<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import { GridComponent, ColumnsDirective, ColumnDirective,
  Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import api from "@/axios";
import moment from "moment";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import {driver} from "driver.js";
import "driver.js/dist/driver.css";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {
    Loader, Layout, PageHeader,
    Multiselect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  data() {

    return {
      flagCompras: false,
      title: "Notas Fiscais",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Notas Fiscais",
          active: true
        }
      ],
      dataList: null,
      loading: true,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,
      showAssocRoma: false,
      idRomaneioAssoc: 0,
      dtListPesqRoma: null,
      showEnviarOrdemColeta: false,
      idsAtualizar: [],

      erroPeriodo: '',
      filterSettings: { type: 'Excel' },
      toolbar: [
          { text: 'Nova Nota Fiscal', prefixIcon: 'e-plus', id: 'novoMov', align: 'Left' },
          { text: 'Gerar Separação', prefixIcon: 'e-text-wrap', id: 'gerarSeparacao', align: 'Left' },
          { text: 'Associar a Romaneio', prefixIcon: 'e-group-2', id: 'associarRomaneio', align: 'Left' },
          { tooltipText: 'Envio de Ordem de Coleta', prefixIcon: 'e-send', id: 'envioOrdemColeta', align: 'Left' },
          { tooltipText: 'Criar Pedido Baseado NF-e', prefixIcon: 'e-insert-right', id: 'criarPedido', align: 'Left' },
          { tooltipText: 'Exportar Excel', prefixIcon: 'e-export-excel', id: 'exportExcel', align: 'Left' },
          { tooltipText: 'Exportar CSV', prefixIcon: 'e-export-csv', id: 'exportCsv', align: 'Left' },
          { text: 'Search', tooltipText: 'Pesquisar'}
      ],

      colsMOV: [
        {
          type: "checkbox",
          headerText: "",
          textAlign: "Left",
        },
        {
          field: "id",
          headerText: "ID",
          textAlign: "Left",
        },
        {
          field: "status",
          headerText: "Status",
          textAlign: "Left",
        },
        {
          field: "stsordcol",
          headerText: "Ordem Coleta",
          textAlign: "Left",
        },
        {
          field: "wmsos_id",
          headerText: "Ordem Serviço",
          textAlign: "Right",
        },
        {
          field: "wmsromaneio_id",
          headerText: "Romaneio",
          textAlign: "Right",
        },
        {
          field: "stsentr",
          headerText: "Entrega",
          textAlign: "Left",
        },
        {
          field: "dtemissao",
          headerText: "Emissão",
          textAlign: "Right",
          format: "dd/MM/yyyy"
        },
        {
          field: "dtcompr",
          headerText: "Comprovante",
          textAlign: "Right",
          format: "dd/MM/yyyy"
        },
        {
          field: "codigo",
          headerText: "NF",
          textAlign: "Right",
        },
        {
          name: "valorliq",
          field: "valorliq",
          headerText: "Valor",
          textAlign: "Right",
          template: "templtvalorliq",
        },
        {
          field: "peso",
          headerText: "Peso",
          textAlign: "Right",
          template: "templtpeso"
        },
        {
          field: "valorfrete",
          headerText: "Frete loja",
          textAlign: "Right",
          template: "templtvalorfrete"
        },
        {
          field: "dtentrega",
          headerText: "Dt.Entrega",
          textAlign: "Right",
          format: "dd/MM/yyyy"
        },
        {
          field: "dtultocor",
          headerText: "Ocorrência",
          textAlign: "Right",
          format: "dd/MM/yyyy"
        },
        {
          field: "obsentr",
          headerText: "Obs.Entrega",
          textAlign: "Left",
        },
        {
          field: "natop",
          headerText: "Natureza",
          textAlign: "Left",
        },
      ],

      colsCTE: [
        {
          field: "numcte",
          headerText: "Número",
          textAlign: "Left",
        },
        {
          field: "dtemicte",
          format: "dd/MM/yyyy",
          headerText: "Emissão",
        },
        {
          field: "dtpreventr",
          format: "dd/MM/yyyy",
          headerText: "Previsão",
        },
        {
          field: "dtpreventrep",
          format: "dd/MM/yyyy",
          headerText: "Previsão Rep.",
        },
        {
          field: "pesocte",
          textAlign: "Right",
          headerText: "Peso",
          template: "templtpesocte"
        },
        {
          field: "valorcte",
          textAlign: "Right",
          headerText: "Valor",
          template: "templtvalorcte"
        },
        {
          field: "valfreteprop",
          textAlign: "Right",
          headerText: "Valor Frete Prop.",
          template: "templtvalfreteprop"
        },
        {
          field: "prazo",
          format: "N",
          textAlign: "Right",
          headerText: "Prazo",
        },
        {
          field: "diasentrega",
          format: "N",
          textAlign: "Right",
          headerText: "Dias Entrega",
        },
        {
          field: "statusPrazo",
          textAlign: "Left",
          headerText: "Status Prazo",
        }
      ],

      colsDEST: [
        {
          field: "destnome",
          textAlign: "Left",
          headerText: "Nome",
        },
        {
          field: "destcnpj",
          textAlign: "Left",
          headerText: "CPF/CNPJ",
        },
        {
          field: "destcidade",
          textAlign: "Left",
          headerText: "Cidade",
        },
        {
          field: "destestado",
          textAlign: "Left",
          headerText: "Estado",
        },
      ],

      colsREMET: [
        {
          field: "remetnome",
          textAlign: "Left",
          headerText: "Nome",
        },
        {
          field: "remetcnpj",
          textAlign: "Left",
          headerText: "CPF/CNPJ",
        },
        {
          field: "remetcidade",
          textAlign: "Left",
          headerText: "Cidade",
        },
        {
          field: "remetestado",
          textAlign: "Left",
          headerText: "Estado",
        },
      ],

      colsTRANSP: [
        {
          field: "nometransp",
          textAlign: "Left",
          headerText: "Nome",
        },
        {
          field: "transpcnpj",
          textAlign: "Left",
          headerText: "CPF/CNPJ",
        },
        {
          field: "transpcidade",
          textAlign: "Left",
          headerText: "Cidade",
        },
        {
          field: "transpestado",
          textAlign: "Left",
          headerText: "Estado",
        },
      ]

    };
  },

  created() {

  },

  mounted() {
    console.log('mounted mov-list_syncfusion')
    this.atualizaDataList()
  },

  provide: {
    grid: [Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport]
  },

  methods: {


    ajuda(){
      console.log('ajuda')
      const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Próximo >',
        prevBtnText: '< Anterior',
        doneBtnText: 'Finalizar',
        steps: [
          { element: '#novoMov', popover: { title: 'Importar Arquivo XML', description: 'Comece por aqui, importando o arquivo XML da sua nota fiscal (NF-e).' } },
        ]
      })
      driverObj.drive()
    },



    apenasCompras(){
      this.flagCompras = !this.flagCompras

      this.atualizaDataList()
    },

    recordDoubleClick(evt){
      console.log('recordDoubleClick')
      console.log(evt.rowData.id);
      const routeData = this.$router.resolve(`/movimento/editar/${evt.rowData.id}`)
      window.open(routeData.href, '_blank')
    },


    confirmarEnvioOrdemColeta() {
      this.showEnviarOrdemColeta = false
      console.log('confirmarEnvioOrdemColeta')
      this.loading = true
      api.get(`${getBaseUrl()}api/movsprogoc`,{
        params: {
          'ids': this.idsAtualizar
        }
      }).then(response => {
        console.log('response.data')
        console.log(response)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento(s) processado(s) com sucesso!",
          text: response.data,
          showConfirmButton: false,
          timer: 3500
        }).then(() => {
          this.atualizaDataList()
        })
      })
    },


    pesqRomaneio(evt){
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },


    confirmarAssocRoma(){
      console.log('confirmarAssocRoma')
      const selectedRecords = this.$refs.dataGrid.getSelectedRecords();
      let idsAtualizar = [];
      let transpRoma = null
      selectedRecords.forEach((index) => {
        idsAtualizar.push(index.id)
        transpRoma = index.transpcnpj
      })
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      this.loading = true
      api.post(`${getBaseUrl()}api/wmsromamov`, {
        idRoma: this.idRomaneioAssoc,
        idsData: idsAtualizar,
        transpmov: transpRoma
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data[0].id)
          window.open(routeData.href, '_blank')
        })
        this.atualizaDataList()
      })
    },


    confirmarAssocRomaNovo(){
      console.log('confirmarAssocRomaNovo')
      const selectedRecords = this.$refs.dataGrid.getSelectedRecords();
      let idsAtualizar = [];
      let transpRoma = null
      selectedRecords.forEach((index) => {
        idsAtualizar.push(index.id)
        transpRoma = index.transpcnpj
      })
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      this.loading = true
      api.post(`${getBaseUrl()}api/wmsromamovnv`, {
        idsData: idsAtualizar,
        transpmov: transpRoma
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showAssocRoma = false
        this.loading = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data[0].id)
          window.open(routeData.href, '_blank')
        })
      })
      this.atualizaDataList()
    },


    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      let difDias = moment(this.dtFimFiltro).diff(moment(this.dtIniFiltro), 'days')
      console.log(difDias)
      if (difDias < 31) {
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
          'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
        }))
        this.showModalPeriodo = false
        this.atualizaDataList()
      } else {
        this.erroPeriodo = 'Diferença entre data inicial e final deve ser menor que 31 dias, caso necessário um período maior favor entrar em contato com suporte.'
      }
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      this.loading = true
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      if (!filtros) {
        let perIniPadrao = moment(new Date()).startOf('month').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).endOf('month').format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      const paramsReq = {
        'di': this.dtIniFiltro,
        'df': this.dtFimFiltro,
        'flagCompras': this.flagCompras
      }
      api.get(`${getBaseUrl()}api/movsnovasf`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data_0')
        console.log(response)
        this.dataList = response.data[0]
        this.dataList.forEach((value) => {
          if (value.dtemissao) {
            if (value.dtemissao){
              value.dtemissao = moment(value.dtemissao).format('DD/MM/YYYY')
            }
            if (value.dtcompr){
              value.dtcompr = moment(value.dtcompr).format('DD/MM/YYYY')
            }
            if (value.dtentrega){
              value.dtentrega = moment(value.dtentrega).format('DD/MM/YYYY')
            }
            if (value.dtultocor){
              value.dtultocor = moment(value.dtultocor).format('DD/MM/YYYY')
            }
            if (value.dtemicte){
              value.dtemicte = moment(value.dtemicte).format('DD/MM/YYYY')
            }
            if (value.dtpreventr){
              value.dtpreventr = moment(value.dtpreventr).format('DD/MM/YYYY')
            }
            if (value.dtpreventrep){
              value.dtpreventrep = moment(value.dtpreventrep).format('DD/MM/YYYY')
            }
          }
        })
        this.loading = false
        const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
        this.title = `(${this.dataList.length}) Notas Fiscais: ${dtIniFormated} - ${dtFimFormated}`
      })
    },

    dataBound: function() {
      this.$refs.dataGrid.autoFitColumns([])
    },


    tbClickHandler: function(args) {
      console.log('tbClickHandler')
      console.log(args.item.id)
      this.loading = true

      if (args.item.id === 'novoMov') {
        console.log('novoMov')
        this.$router.push(`/movimento/importar/0`)
      }

      else if (args.item.id === 'gerarSeparacao') {
        console.log('gerarSeparacao')
        const selectedRecords = this.$refs.dataGrid.getSelectedRecords();
        let idsAtualizar = [];
        if (selectedRecords.length > 0) {
          selectedRecords.forEach((index) => {
            idsAtualizar.push(index.id)
          });
          console.log('idsAtualizar')
          console.log(idsAtualizar)
          Swal.fire({
            position: "center",
            icon: "question",
            input: 'select',
            inputValue: 't',
            inputOptions: {
              t: 'Todos os movimentos',
              s: 'Contendo produtos de Saldo Positivo'
            },
            title: "Gerar Ordens de Serviço (Movimentos " + idsAtualizar + ")",
            text: "Esta operação é irreversível, tem certeza que deseja continuar?",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true,
          }).then(result => {
            console.log(result)
            console.log(result.value)
            if (result.value) {
              this.loading = true
              console.log('vai Atualizar')
              api.get(`${getBaseUrl()}api/movsgeraos`,{
                params: {
                  'ids': idsAtualizar,
                  'tipo': result.value
                }
              }).then(response => {
                console.log('response.data')
                console.log(response)
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Movimento(s) processado(s) com sucesso!",
                  text: response.data,
                  showConfirmButton: false,
                  timer: 3500
                }).then(() => {
                  //this.refeFormTable()

                  // this.dataGrid.clearSelection()
                  location.reload()
                  //
                })
                this.loading = false
              })
            }
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Nenhum movimento foi selecionado, favor selecionar.",
            showConfirmButton: false,
            timer: 1500
          })
        }
      }

      else if (args.item.id === 'associarRomaneio') {
        console.log('associarRomaneio')
        const selectedRecords = this.$refs.dataGrid.getSelectedRecords();
        let idsAtualizar = [];
        if (selectedRecords.length > 0) {
          selectedRecords.forEach((index) => {
            idsAtualizar.push(index.id)
          });
          console.log('idsAtualizar')
          console.log(idsAtualizar)
          this.showAssocRoma = true
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor selecionar algum movimento antes de associar.",
            showConfirmButton: false,
            timer: 1500
          })
        }
      }

      else if (args.item.id === 'envioOrdemColeta') {
        console.log('envioOrdemColeta')
        this.idsAtualizar = []
        const selectedRecords = this.$refs.dataGrid.getSelectedRecords();
        if (selectedRecords.length > 0) {
          selectedRecords.forEach((index) => {
            this.idsAtualizar.push(index.id)
          });
          this.showEnviarOrdemColeta = true
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Nenhum movimento foi selecionado, favor corrigir.",
            showConfirmButton: false,
            timer: 1500
          })
        }
      }

      else if (args.item.id === 'criarPedido') {
        console.log('criarPedido')
        const selectedRecords = this.$refs.dataGrid.getSelectedRecords();
        let listaNotas = [];
        if (selectedRecords.length > 0) {
          selectedRecords.forEach((index) => {
            listaNotas.push(index.id)
          });
          console.log('listaNotas')
          console.log(listaNotas)
          Swal.fire({
            position: 'center',
            icon: 'info',
            text: 'Deseja criar 1 pedido para cada nota(1-1) ou 1 pedido para todas as notas(1-n)?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Coletivo',
            cancelButtonText: 'Individual'
          }).then(selected => {
            api.get(`${getBaseUrl()}api/movgerapedido`,{
              params: {
                'ids': listaNotas,
                'multiplosPedidos': selected.isConfirmed
              }
            }).then(response => {
              console.log(response.data)
              if(!response.data.success){
                Swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  text: response.data.message,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 4000
                })
              }else{
                Swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  text: 'Redirecionando para página de pedidos',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 3000
                }).then(() => {
                  if(selected.isConfirmed){
                    this.$router.replace(`/pedido/detalhe/${response.data.pedido_id}`)
                  }else{
                    this.$router.replace(`/pedidos/list`)
                  }
                })
              }
            })
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Nenhum movimento foi selecionado, favor corrigir.",
            showConfirmButton: false,
            timer: 1500
          })
        }
      }

      else if (args.item.id === 'exportExcel') {
        const fileProps = {
          fileName: 'movimentos.xlsx'
        }
        this.$refs.dataGrid.excelExport(fileProps)
      }

      else if (args.item.text === 'exportCsv') {
        const fileProps = {
          fileName: 'movimentos.csv'
        }
        this.$refs.dataGrid.csvExport(fileProps)
      }

      this.loading = false
    },


    rowDataBound: function (args) {
      const valStatus = args.data["status"]
      args.row.classList.add("sts-"+ valStatus.toLowerCase())
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>
    <div class="d-flex mb-2">
      <h5 class="font-size-14 mx-2">Listar apenas entradas?</h5>
      <b-form-checkbox switch size="md" v-model="flagCompras" @click="apenasCompras">
        {{ flagCompras === true ? 'On' : 'Off' }}
      </b-form-checkbox>
    </div>
    <Loader v-if="loading" style="min-height: 300px;">
    </Loader>
    <div v-if="!loading">
      <ejs-grid :dataSource="dataList"
                ref="dataGrid"
                :allowFiltering="true"
                :allowPdfExport="true"
                :allowExcelExport="true"
                :allowPaging="true"
                :filterSettings="filterSettings"
                :toolbar="toolbar"
                :recordDoubleClick="recordDoubleClick"
                :toolbarClick="tbClickHandler"
                :dataBound="dataBound"
                :rowDataBound="rowDataBound"
                :pageSettings="{ pageSizes: ['30', '100', '200', '500', 'All'], pageSize: 30 }"
                :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
        <e-columns>
          <e-column headerText="MOVIMENTO" :columns="colsMOV" textAlign="Center"></e-column>
          <e-column headerText="CTE" :columns="colsCTE" textAlign="Center"></e-column>
          <e-column headerText="DESTINATÁRIO" :columns="colsDEST" textAlign="Center"></e-column>
          <e-column headerText="REMETENTE" :columns="colsREMET" textAlign="Center"></e-column>
          <e-column headerText="TRANSPORTADOR" :columns="colsTRANSP" textAlign="Center"></e-column>
        </e-columns>

        <template v-slot:templtvalorliq="{data}">
          <div> {{formatDecimal(data.valorliq)}} </div>
        </template>
        <template v-slot:templtpeso="{data}">
          <div> {{formatDecimal(data.peso)}} </div>
        </template>
        <template v-slot:templtvalorfrete="{data}">
          <div> {{formatDecimal(data.valorfrete)}} </div>
        </template>
        <template v-slot:templtpesocte="{data}">
          <div> {{formatDecimal(data.pesocte)}} </div>
        </template>
        <template v-slot:templtvalorcte="{data}">
          <div> {{formatDecimal(data.valorcte)}} </div>
        </template>
        <template v-slot:templtvalfreteprop="{data}">
          <div> {{formatDecimal(data.valfreteprop)}} </div>
        </template>

      </ejs-grid>
    </div>



    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="perexib">Selecionar Data Inicial e Final</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <b-alert v-if="this.erroPeriodo !== ''"  show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i> {{ erroPeriodo }}
      </b-alert>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal title="Associar a Romaneio"
             size="lg"
             v-model="showAssocRoma"
             centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Romaneio  {{ idRomaneioAssoc }}</span>
          <multiselect id="inputRomaneio"
                       @search-change="pesqRomaneio"
                       v-model="idRomaneioAssoc"
                       placeholder="Pesquisar romaneio"
                       :options="dtListPesqRoma"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.id }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.motorista }}</div>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showAssocRoma = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button variant="outline-success" class="ms-1" @click="confirmarAssocRomaNovo">
            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
            Criar e Associar a Novo Romaneio
          </b-button>
          <b-button :disabled="idRomaneioAssoc === 0"
                    type="submit" variant="success" class="ms-1" @click="confirmarAssocRoma()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>



    <b-modal title="Enviar Ordem de Coleta"
             size="md"
             v-model="showEnviarOrdemColeta"
             centered hide-footer>
      <div class="row">
        <div class="col-md-12">
          <div class="col-sm-12 mt-3 mb-3">
            <div class="mb-3">
              <h4>Movimentos:</h4>
              <span class="text-dark mb-4">{{ idsAtualizar }}</span>
            </div>
          </div>
          <div class="text-end mt-5">
            <b-button variant="light" @click="showEnviarOrdemColeta = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="confirmarEnvioOrdemColeta">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>


    </b-modal>


  </Layout>
</template>

<style>

.sts-el {
  background-color: rgba(78,59,0,0.5);
}
.sts-cf {
  background-color: rgba(0,58,78,0.5);
}
.sts-enp {
  background-color: rgba(33,78,0,0.5);
}
.sts-ecr {
  background-color: rgba(146,20,0,0.5);
}
.sts-eat {
  background-color: rgba(146,20,0,0.5);
}
.sts-ned {
  background-color: rgba(146,73,0,0.5);
}
.sts-nef {
  background-color: rgba(146,20,0,0.5);
}
.sts-sct {
  background-color: rgba(146,111,0,0.5);
}
.sts-cct {
  background-color: rgba(0,58,78,0.5);
}
.sts-tra {
  background-color: rgba(146,20,0,0.5);
}
.sts-can {
  background-color: rgba(146,20,0,0.5);
}

#btnAjuda .dx-icon {
  color: #fff !important;
}

</style>
